import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PlaceholderPage({ title }: { title: string }) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{title}</h1>
        <p className="text-foreground-600">Coming soon</p>
      </div>
      <Footer />
    </div>
  );
}